/* eslint-disable max-len */
import React from 'react';

export const FolderOutline = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' aria-hidden='true'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.5 4.5A1.5 1.5 0 003 6v3.401A2.986 2.986 0 014.5 9h15c.546 0 1.059.146 1.5.401V9a1.5 1.5 0 00-1.5-1.5h-5.379a2.25 2.25 0 01-1.59-.659L10.408 4.72a.75.75 0 00-.53-.22H4.5zM21 12a1.5 1.5 0 00-1.5-1.5h-15A1.5 1.5 0 003 12v6a1.5 1.5 0 001.5 1.5h15A1.5 1.5 0 0021 18v-6zm1.5 6a3 3 0 01-3 3h-15a3 3 0 01-3-3V6a3 3 0 013-3h5.379a2.25 2.25 0 011.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 013 3v9z'
                fill='currentcolor'
            />
        </svg>
    );
};
